import { FormControl } from '@angular/forms';
import { ApplianceDetailsSteppedMultiPlanForm } from '../../models/appliance-details-stepped-multi-plan/appliance-details-stepped-multi-plan-form.interface';
import { ApplianceDetailsSteppedFormField } from '../../models/appliance-details-stepped/appliance-details-stepped-form-field.enum';

export const mockApplianceDetailsSteppedMultiPlanForm: ApplianceDetailsSteppedMultiPlanForm =
  {
    [ApplianceDetailsSteppedFormField.ApplianceCodeBuiltIn]: new FormControl(
      null
    ),
    [ApplianceDetailsSteppedFormField.BrandCode]: new FormControl(null),
    [ApplianceDetailsSteppedFormField.PurchaseDate]: new FormControl(null),
    [ApplianceDetailsSteppedFormField.PurchasePrice]: new FormControl(null),
  };
